import customCommon from '@assets/css/custom-common.css';

/**
 * Custom common styles.
 * @type {CSSStyleSheet}
 */
export const customCommonStyles = new CSSStyleSheet();
customCommonStyles.replaceSync(customCommon);
